import { ZapOrcaApp } from './app';

document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('app');
  if (appContainer) {
    const app = new ZapOrcaApp(appContainer);
    app.render();
  }
});
